// extracted by mini-css-extract-plugin
module.exports = {"st-section":"home_st-section___apIo","st-section__head":"home_st-section__head__1o-p4"};